import React, { useContext, useState } from 'react';
import { neverop } from 'utils/noop';

interface HeroCarouselProviderProps {
    children: React.ReactNode;
}

export type HeroCarouselContextType = {
    disableAutoPlay: () => void;
    enableAutoPlay: () => void;
    isAutoPlayAuthorized: boolean;
};

export const defaultHeroCarouselContext = {
    disableAutoPlay: neverop('HeroCarouselContext', 'disableAutoPlay'),
    enableAutoPlay: neverop('HeroCarouselContext', 'enableAutoPlay'),
    isAutoPlayAuthorized: true,
};

export const HeroCarouselContext = React.createContext<HeroCarouselContextType>(
    defaultHeroCarouselContext,
);

export const HeroCarouselProvider = ({
    children,
}: HeroCarouselProviderProps): JSX.Element => {
    const [isAutoPlayAuthorized, setIsAutoPlayAuthorized] = useState(true);

    const disableAutoPlay = () => {
        setIsAutoPlayAuthorized(false);
    };

    const enableAutoPlay = () => {
        setIsAutoPlayAuthorized(true);
    };

    return (
        <HeroCarouselContext.Provider
            value={{
                disableAutoPlay,
                enableAutoPlay,
                isAutoPlayAuthorized,
            }}
        >
            {children}
        </HeroCarouselContext.Provider>
    );
};

export const useHeroCarouselContext = (): HeroCarouselContextType =>
    useContext(HeroCarouselContext);

export default HeroCarouselProvider;
